import React from "react";
import { Container } from "react-bootstrap";
import "./MainScreen.css";

const MainScreen = ({ title, children }) => {
  return (
    <div className="main-wrapper">
      <div className="main-content">
        <Container fluid>
          {title && (
            <div className="page-title">
              <h1 className="heading">{title}</h1>
              <hr />
            </div>
          )}
          <div className="page-body">
            {children}
          </div>
        </Container>
      </div>
      <footer className="main-footer">
        © 2025 CLMS — All rights reserved.
      </footer>
    </div>
  );
};

export default MainScreen;
